import { parseAsString, useQueryState } from 'nuqs'
import { Text } from 'ui-kit/typography'
import classes from './ScenariosError.module.scss'

export const ScenariosError = () => {
  const [searchQuery] = useQueryState('search', parseAsString.withDefault(''))

  return (
    <Text size={'lg'} className={classes.message}>
      Sorry, we couldn't find any scenarios matching your search query{' '}
      <Text as={'span'} size={'lg'} className={classes.text}>
        "{searchQuery}"
      </Text>
      .
    </Text>
  )
}
